module.exports = __webpack_public_path__ + "img/1479645315.6ce600d4.jpg";